import { ref } from 'vue';

const toasts = ref([]); // { id, message, variant: 'success'|'error'|'info', action? }
let _id = 0;
export function useToast() {
  function show(message, { action = null, duration = 4000, variant = 'info' } = {}) {
    const id = ++_id;
    toasts.value.push({ action, id, message, variant });
    if (duration > 0) setTimeout(() => dismiss(id), duration);
    return id;
  }

  function dismiss(id) {
    const i = toasts.value.findIndex(t => t.id === id);
    if (i !== -1) toasts.value.splice(i, 1);
  }

  return { dismiss, show, toasts };
}
